import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Wordmark from '../components/Wordmark';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const homeTarget = user ? '/' : '/landing';

  return (
    <div
      data-testid="not-found-page"
      style={{
        minHeight: '100vh',
        background: '#0E1110',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Wordmark top-left */}
      <header style={{ padding: '20px 24px' }}>
        <Link
          to="/landing"
          data-testid="not-found-wordmark-link"
          style={{ display: 'inline-block' }}
        >
          <Wordmark className="h-[28px]" />
        </Link>
      </header>

      {/* Centered content */}
      <main
        style={{
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px 24px 80px',
          textAlign: 'center',
        }}
      >
        <h1
          data-testid="not-found-code"
          style={{
            fontFamily: 'var(--s8-font-display)',
            fontWeight: 600,
            fontSynthesis: 'none',
            fontVariantNumeric: 'tabular-nums',
            fontSize: 'clamp(96px, 18vw, 168px)',
            letterSpacing: '-0.01em',
            color: 'var(--s8-amber)',
            lineHeight: 1.15,
            margin: 0,
          }}
        >
          404
        </h1>

        <div
          data-testid="not-found-title"
          style={{
            fontFamily: 'var(--s8-font-display)',
            fontWeight: 600,
            fontSynthesis: 'none',
            fontSize: 'clamp(28px, 5vw, 44px)',
            letterSpacing: '-0.01em',
            color: '#F0EBE0',
            marginTop: 16,
            lineHeight: 1.15,
          }}
        >
          Page not found.
        </div>

        <p
          data-testid="not-found-subtitle"
          style={{
            fontFamily: "'Barlow', sans-serif",
            fontSize: 15,
            color: '#a39889',
            marginTop: 12,
            maxWidth: 460,
            lineHeight: 1.55,
          }}
        >
          The page you&apos;re looking for doesn&apos;t exist or has moved.
        </p>

        <button
          type="button"
          onClick={() => navigate(homeTarget)}
          data-testid="not-found-home-btn"
          style={{
            marginTop: 32,
            fontFamily: "'DM Mono', monospace",
            fontSize: 13,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            padding: '12px 28px',
            background: '#C8923E',
            color: '#0E1110',
            borderRadius: 6,
            border: 'none',
            cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          Back to STAGE8
        </button>
      </main>
    </div>
  );
}
